









import { Component, Prop, Vue } from 'vue-property-decorator';

import { Fuel } from '@/models/fuel.model';

@Component
export default class FuelLabel extends Vue {
  @Prop() fuel!: Fuel;
}
